<template>
    <div class="form-group company-row -mx-2 flex flex-wrap">
        <label class="form-label w-3/12 px-2">Company</label>
        <div class="w-9/12 px-2">
            <div class="form-label p-0">
                <select
                    id="select-company"
                    aria-label="Select company"
                    data-id="company_id"
                    name="company_id"
                >
                    <option
                        v-for="company in props.companies"
                        :key="company.id"
                        :value="company.id"
                    >
                        {{ company.name }}
                    </option>
                </select>
                <span
                    id="company_id_error"
                    class="form-control-error-description text-danger"
                    data-id="company_id.error"
                ></span>
            </div>
        </div>
    </div>
    <div class="form-group branch-row -mx-2 flex flex-wrap">
        <label class="form-label w-3/12 px-2">Branch</label>
        <div class="w-9/12 px-2">
            <div class="form-label p-0">
                <select
                    id="select-branch"
                    aria-label="Select branch"
                    data-id="branch_id"
                    name="branch_id"
                >
                    <!-- {{-- Populated by jQuery --}} -->
                </select>
                <span
                    id="branch_id_error"
                    class="form-control-error-description text-danger"
                    data-id="branch_id.error"
                ></span>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
const props = defineProps<{
    companies: { id: string; name: string }[];
}>();
</script>
